import { Service } from '../types/service';
import { colors } from '../styles/theme';

export const services: Service[] = [
  {
    iconName: "Palette",
    title: "Canva Pro",
    description: "Premium access to Canva Pro for creating professional designs",
    highlight: "Free",
    color: colors.secondary,
    link: "/services/canva-pro"
  },
  {
    iconName: "Globe",
    title: "Web Hosting",
    description: "Free hosting for your student web projects",
    highlight: "Free",
    color: colors.tertiary,
    link: "/services/hebergement"
  },
  {
    iconName: "BookOpen",
    title: "Forum",
    description: "Create your own online forum for your project",
    highlight: "Free",
    color: colors.accent1,
    link: "/services/ressources"
  },
  {
    iconName: "Code",
    title: "Virtual Private Server",
    description: "A VPS tailored for your student projects, available 24/7!",
    highlight: "Free",
    color: colors.accent2,
    link: "/services/vps"
  },
  {
    iconName: "Laptop",
    title: "Office 365",
    description: "Access to Office 365 software suite for your studies",
    highlight: "Free",
    color: colors.accent3,
    link: "/services/logiciels"
  },
  {
    iconName: "Mails",
    title: "Email",
    description: "An email server tailored for student life",
    highlight: "Free",
    color: colors.primary,
    link: "/services/mail"
  }
];